import { getDocumentById } from './getDocumentById';
export const resolveDocumentHref = (documentId) => getDocumentById(documentId)?.route;
//# sourceMappingURL=resolveDocumentHref.js.map